namespace GeniuzPOS.Lookups {
    export interface VwPosFuncRow {
        Id?: number;
        FuncId?: string;
        FuncDesc?: string;
        FunLevel?: number;
        FuncUsage?: number;
        FullName?: string;
    }

    export namespace VwPosFuncRow {
        export const idProperty = 'Id';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwPosFunc';
        export const lookupKey = 'VwPosFuncRow';

        export function getLookup(): Q.Lookup<VwPosFuncRow> {
            return Q.getLookup<VwPosFuncRow>('VwPosFuncRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            FuncId = "FuncId",
            FuncDesc = "FuncDesc",
            FunLevel = "FunLevel",
            FuncUsage = "FuncUsage",
            FullName = "FullName"
        }
    }
}
